import { useSelector } from 'react-redux';
import { authProfile } from 'redux/auth/selectors';
import { citiesGlobalsSelector } from 'redux/globals/selectors';

export interface City {
  id?: number;
  countryId?: number;
  lat?: number;
  lng?: number;
  name?: string;
  timeZone?: string;
  twoLetterISOCode?: string;
}

export default function useUserCityPosition() {
  const profile = useSelector(authProfile);
  const cities = useSelector(citiesGlobalsSelector);
  const city = cities?.find((c: City) => c.id === profile.cityID);

  // Si la ciudad no tiene geolocalización, no usar 0,0 porque es una ubicación real (en el océano atlántico), usar Buenos Aires como fallback
  const safeGeolocation = {
    lat: city?.lat && city.lat !== 0 ? city.lat : -34.6037,
    lng: city?.lng && city.lng !== 0 ? city.lng : -58.3816,
  };

  return {
    lat: safeGeolocation.lat,
    lng: safeGeolocation.lng,
  };
}
